import React from 'react';
import { useNavigation, useTranslate } from '@refinedev/core';
import { Box, Container, Paper, Typography } from '@mui/material';
import { CreateButton } from '@refinedev/mui';
import { DataGrid } from '@mui/x-data-grid';
import { useStudiesList } from '@/features/studies/hooks';
import { StudyFilters } from '@/features/studies/components';
import { searchContainerStyles } from '@/features/studies/styles';
import { useCreateDraftStudy } from '../hooks/useCreateDraftStudy';
import { useTranslation } from 'react-i18next';
import { getDataGridLocalization } from '../constants/dataGridLocalization';

export const StudyList: React.FC = () => {
  const translate = useTranslate();
  const { t } = useTranslation();
  const { dataGridProps, search, defaultFilters, columns } = useStudiesList();
  const localeText = getDataGridLocalization(t);

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          mb: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h4">
          {translate('pages.studies.list.title', 'Studies')}
        </Typography>
        <CreateStudyButton />
      </Box>

      <Paper sx={searchContainerStyles}>
        <StudyFilters onSearch={search} defaultFilters={defaultFilters} />
      </Paper>

      <DataGrid
        {...dataGridProps}
        columns={columns}
        pageSizeOptions={[10, 25, 50]}
        disableRowSelectionOnClick
        disableColumnFilter
        autoHeight
        localeText={localeText}
      />
    </Container>
  );
};

const CreateStudyButton = () => {
  const { edit } = useNavigation();
  const { createDraft, isLoading } = useCreateDraftStudy();
  const handleCreateStudy = () => {
    createDraft({
      onSuccess: (study) => {
        edit(`admin/studies`, study.id);
      },
    });
  };

  return (
    <CreateButton
      resource="admin/studies"
      onClick={handleCreateStudy}
      loading={isLoading}
    />
  );
};
